import axiosInstance from '../axiosClient';

/**
 * Get all members of an organization
 * @param {string} token - Auth token
 * @param {string} orgUuid - Organization UUID
 * @returns {Promise} - Organization members array
 */
export const getOrganizationMembers = async (token, orgUuid) => {
  try {
    const response = await axiosInstance.get(`/organization/${orgUuid}/members`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
